export function cloudinaryImageQualityModify(imageUrl) {
    return imageUrl.replace('http://', 'https://').replace('upload/', 'upload/q_auto/')
}